import React from 'react';
import styled from 'styled-components';

import { Stack } from '../../stack/stack';

type Props = {
  children: React.ReactNode;
};

const ToolbarGroup = (props: Props) => {
  return (
    <Component direction="row" spacing={0.2}>
      {props.children}
    </Component>
  );
};

const Component = styled(Stack)`
  font-size: 0.8rem;

  &:not(:last-child)::after {
    content: '';

    width: 1px;
    height: 100%;
    margin: 0 0.75em 0 0.75em;
    background-color: #ccc;
  }
`;

export { ToolbarGroup };
